const listPointsBody = document.querySelector('#FestSchedule').querySelector('div[name=body]');
// import auth from '../tools/storage.js';

const selectTimeZone = document.querySelector('#FestSchedule').querySelector('select[name=listTimeZone]');
export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },

  strToDate(dtStr) {
    let dateParts = dtStr.split("-");
    let timeParts = dateParts[2].split(" ")[1].split(":");
    dateParts[2] = dateParts[2].split(" ")[0];

    return  new Date(dateParts[0], dateParts[1] - 1, dateParts[2], timeParts[0], timeParts[1], timeParts[2]);
  },

  drawDataInContainer(enterprisesData) {
    // listPointsBody.innerHTML = `<div class="schedule-header">
    //                               <div class="schedule-column">Время</div>
    //                               <div class="schedule-column">Название </div>   
    //                               <div class="schedule-column">Локация</div>    
    //                           </div>`;

    listPointsBody.innerHTML = '';
     
    const ParentDivWidth = listPointsBody.getBoundingClientRect().width * 0.96;
    let maxID = 0;
    if (enterprisesData) {
      let maxMinSec = 0;
      let minMinSec = 10000000;
      // console.log(enterprisesData);
      let sortByHallData = enterprisesData.slice();
      // alert('sort');
      sortByHallData.sort(function(a, b) {
        let aHid = a['hid'];
        let bHid = b['hid'];

        if(!aHid)
          aHid = 0;

        if(!bHid)
          bHid = 0;

         return (parseInt(aHid) - parseInt(bHid));
      });

    
      let startDay = -1;

      sortByHallData.forEach((element) => {
        let date = this.strToDate(element.timeStart);
        date = new Date(date.getTime() + (selectTimeZone.value * 60 * 60) * 1000);
        if(startDay < 0 || startDay > date.getDate())
          startDay = date.getDate();
      });

      sortByHallData.forEach((element) => {
        console.log(element);
        let date = this.strToDate(element.timeStart);
        date = new Date(date.getTime() + (selectTimeZone.value * 60 * 60) * 1000);
        let startMINSEC = date.getHours()*60 +date.getMinutes();
        // if(startDay < 0 || startDay > date.getDate())
        //   startDay = date.getDate();

        let minBonus = 0;
        // if(minMinSec < startMINSEC && startDay != date.getDate())
        if(startDay < date.getDate())
          minBonus = 24*60;
        else if(startDay > date.getDate())
          minBonus = -24*60;
          
        startMINSEC += minBonus;


        if(minMinSec > startMINSEC)
            minMinSec = startMINSEC;
         

        if (element.timeEnd) {
          let dateEnd = this.strToDate(element.timeEnd);
          dateEnd = new Date(dateEnd.getTime() + (selectTimeZone.value * 60 * 60) * 1000);
          let endMINSEC = dateEnd.getHours()*60 +dateEnd.getMinutes();

          // if(minMinSec < startMINSEC && startDay != dateEnd.getDate())
          //   minBonus = 24*60;
          if(startDay < dateEnd.getDate())
            minBonus = 24*60;
          else if(startDay > dateEnd.getDate())
            minBonus = -24*60;
          
          endMINSEC += minBonus;

          if(maxMinSec < endMINSEC)
              maxMinSec = endMINSEC;
        } else if(maxMinSec < startMINSEC)     
          maxMinSec = startMINSEC;
        

      });

      minMinSec = (minMinSec - (minMinSec%60));

      let newmaxMinSec = (maxMinSec - (maxMinSec%60));

      if(newmaxMinSec < maxMinSec)
        maxMinSec = newmaxMinSec + 60;

      if (minMinSec > 720)
        minMinSec = 720;


      if (maxMinSec < 1140)
        maxMinSec = 1140;

      let difTime = maxMinSec - minMinSec;
      let koef = ParentDivWidth/difTime;
      let koefBackgroundStep = ParentDivWidth / (difTime/ 60);

      let toplevelBefore = -1;
      let shiftAndWidthBefore = -1;

      let toplevel = 0;
      let hallBefore = sortByHallData[0].hid;
     
      let newHTMLTablo = `<h6 style="top:0px; left:20px;" class="scheduleTimeLineHallName" ><b>${sortByHallData[0].placeName ? sortByHallData[0].placeName :''}</b> - ${sortByHallData[0].hname ? sortByHallData[0].hname : 'Основной зал'}</h6>`;
      

      sortByHallData.forEach((element) => {


        let nodeData = ` scheduleid = ${element.id} `;
        if(hallBefore != element.hid) {
          hallBefore = element.hid;
            ++toplevel;
            newHTMLTablo += `<h6 style="top:${130*toplevel}px;  left:20px;"  class="scheduleTimeLineHallName" > <b>${element.placeName} </b>- ${element.hname ? element.hname : 'Основной зал'}</h6>`;
          };

        let date = this.strToDate(element.timeStart);

        date = new Date(date.getTime() + (selectTimeZone.value * 60 * 60) * 1000);

        let bonusMin = 0;
        if(startDay != date.getDate())
                bonusMin = 24*60;

        let startMINSEC = date.getHours()*60 +date.getMinutes() + bonusMin;
        let shiftStart = startMINSEC - minMinSec;


        let cloudWidth = 60;
        if(element.timeEnd){
          let dateEnd = this.strToDate(element.timeEnd);
          dateEnd = new Date(dateEnd.getTime() + (selectTimeZone.value * 60 * 60) * 1000);

          if(startDay != dateEnd.getDate())
            bonusMin = 24*60;

          let endMINSEC = dateEnd.getHours()*60 +dateEnd.getMinutes() + bonusMin;
          cloudWidth = endMINSEC - startMINSEC;
        }
        let conflictClass = '';

        if(toplevel == toplevelBefore && shiftAndWidthBefore > (koef*shiftStart ) )
          conflictClass = 'conflict';

        if(element.programID)
          conflictClass += ' typeProgram';
        
        toplevelBefore = toplevel;
        shiftAndWidthBefore = cloudWidth * koef + koef*shiftStart;

        newHTMLTablo += `<div  ${nodeData} class = "scheduleTimeLineCloud ${conflictClass}" style="top:${130*toplevel + 52}px; left:${ koef*shiftStart}px; width:${cloudWidth * koef}px;" alt="${element.name}"> ${element.name ? element.name : ''}</div>`;
       
      });
      ++toplevel;

      newHTMLTablo = `<div class="row m-0 p-0 w-100">  ${this.makeRowWithHourTitles(minMinSec, maxMinSec)}  </div>
                          <div  class = "column  p-0  mt-10 grid-gradient"
                                style = "margin-left:2%; margin-right:2%; width:96%; min-height:${130 * (toplevel) }px; background-size: ${koefBackgroundStep}px 10000px; position:relative;">
                                ${newHTMLTablo}`;

    
      newHTMLTablo += `</div>
                      <div class="row m-0 p-0  mt-3 w-100">  ${this.makeRowWithHourTitles(minMinSec, maxMinSec)}  </div>`;
      newHTMLTablo = `<div class =" w-100  p-0 m-0" >${newHTMLTablo}`;
     

      newHTMLTablo += '</div>';
      listPointsBody.innerHTML = newHTMLTablo;
    };
  },
  makeRowWithHourTitles(minMin, maxMin){

    let htmRow = '';

    do{
      let time = minMin;
      let h = time/60;
      let m = time%60;

      if(h > 24)
          h-=24;

      if (h < 10)
        h = `0${h}`;

      if (m < 10)
        m = `0${m}`;

      htmRow += `<div class="cloudTime">${h}:${m}</div>`;
      minMin +=60;

    } while(minMin <= maxMin);
    return htmRow;
  },

  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  }
};
